import React, { useContext, useEffect, useState } from 'react'
import MDEditor from '@uiw/react-md-editor'
import { FiEdit } from 'react-icons/fi'
import { MdDeleteOutline } from 'react-icons/md'
import { useNavigate, useParams } from 'react-router-dom'
import { USER_CONTEXT } from '../context/ContextProvider'
import { useAuth } from '@clerk/clerk-react'

const Task = () => {
  let [height, setHeight] = useState(120)
  let navigate = useNavigate()
  let { id } = useParams()
  let auth = useAuth()
  let { data, setData } = useContext(USER_CONTEXT)
  let task = data.tasks.find((task) => task.id == id)

  useEffect(() => {
    let element = document.getElementsByClassName('wmde-markdown')[0]
    setHeight(element.clientHeight)
  }, [])

  return (
    <div className="">
      <h1 className="mt-3 text-white text-4xl max-w-2xl mx-auto font-black text-center">
        {task.title}
      </h1>
      <h2 className="text-gray-400 mt-3 text-lg text-center max-w-xl mx-auto">
        {task.title}
      </h2>
      <div className="max-w-4xl mx-auto">
        <div className="mt-5 py-6 border-b border-t border-gray-700 flex justify-between items-center">
          <div className="flex gap-x-2">
            <img className="w-12 h-12 rounded-full" src={task.creator.avatar} />
            <div>
              <p className="font-bold text-base text-gray-300">
                {task.creator.name}
              </p>
              <p className="font-light text-sm text-gray-500">
                Published at {task.createdAt}
              </p>
            </div>
          </div>
          <div
            className={` gap-x-4 ${
              task.creator.id == auth.userId ? 'flex' : 'hidden'
            } `}
          >
            <button
              onClick={() => navigate('/edit/' + id)}
              className="flex items-center gap-x-1 text-white"
            >
              <p>Edit</p>
              <FiEdit className="text-white cursor-pointer" />
            </button>
            <button
              onClick={() => {
                setData({ type: 'DELETE_TASK', payload: { id } })
                navigate('/')
              }}
              className="flex items-center gap-x-1 text-[#C11574] bg-[#C11574] bg-opacity-5 rounded-full px-2 py-0.5"
            >
              <p>Delete</p>
              <MdDeleteOutline className=" cursor-pointer w-5 h-auto" />
            </button>
          </div>
        </div>
        <div className="w-full flex justify-center mt-10 gap-x-2">
          {task.tags.split(' ')?.map((tag) => (
            <span className="bg-[#026AA2] py-1 px-3 font-medium text-sm text-[#026AA2] bg-opacity-5 w-fit rounded-lg">
              {tag}
            </span>
          ))}
        </div>

        <div data-color-mode="dark" className="py-10 bg-transparent ">
          <MDEditor
            hideToolbar
            draggable={'false'}
            height={height + 70}
            style={{
              background: 'transparent',
            }}
            id="md-editor"
            value={task.description}
            onChange={(e) => {}}
            preview="preview"
            className={`overflow-visible bg-transparent`}
            enableScroll={false}
          />
        </div>
      </div>
    </div>
  )
}

export default Task
